const HARD_DEFAULT_TENANT_ID = 'FFF290E2-45E8-4FBC-8E85-0BA824B64329'

export const DEFAULT_TENANT_ID = process.env.REACT_APP_DEFAULT_TENANT_ID ?? HARD_DEFAULT_TENANT_ID
export const SELECTED_SITE_KEY = 'eptw:selectedSiteId'

const normalizeTenantToken = (value: unknown) => {
  if (typeof value !== 'string') {
    return null
  }

  const trimmed = value.trim()
  return trimmed.length > 0 ? trimmed : null
}

export const getPersistedSelectedSiteId = () => {
  if (typeof window === 'undefined') {
    return null
  }

  try {
    return normalizeTenantToken(sessionStorage.getItem(SELECTED_SITE_KEY))
  } catch {
    return null
  }
}

export const resolveTenantCandidate = (...candidates: Array<unknown>) => {
  for (const candidate of candidates) {
    const normalized = normalizeTenantToken(candidate)
    if (normalized) {
      return normalized
    }
  }

  return null
}

export const resolveTenantId = (...candidates: Array<unknown>) =>
  resolveTenantCandidate(...candidates) ?? DEFAULT_TENANT_ID
